<template>
  <a-modal :title="title" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item
        label="账号名称"
        :validate-status="form.getFieldError('username') ? 'error' : ''"
        :help="form.getFieldError('username') ? form.getFieldError('username').join(', ') : ''">
        <a-input
          v-decorator="['username', {
            rules: [
              { required: true, message: '请输入账号名称' },
              { validator: validateUserName }
            ]
          }]"
          placeholder="请输入" />
      </a-form-item>

      <a-form-item
        label="账号密码"
        v-if="!account"
        :validate-status="form.getFieldError('password') ? 'error' : ''"
        :help="form.getFieldError('password') ? form.getFieldError('password').join(', ') : ''">
        <a-input
          type="password"
          v-decorator="['password', {
            rules: [
              { required: true, message: '请输入账号密码' },
              { validator: validatePassword }
            ]
          }]"
          placeholder="请输入（8位以上数字+字母）" />
      </a-form-item>

      <a-form-item
        label="联系方式"
        :validate-status="form.getFieldError('mobile') ? 'error' : ''"
        :help="form.getFieldError('mobile') ? form.getFieldError('mobile').join(', ') : ''">
        <a-input
          v-decorator="['mobile', {
            rules: [
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
            ]
          }]"
          placeholder="请输入" />
      </a-form-item>

      <a-form-item
        label="授权数量"
        :validate-status="form.getFieldError('max') ? 'error' : ''"
        :help="form.getFieldError('max') ? form.getFieldError('max').join(', ') : ''">
        <a-input-number
          v-decorator="['max', {
            rules: [
              { required: true, message: '请输入授权数量' },
              { type: 'number', min: 1, message: '授权数量必须大于0' }
            ]
          }]"
          :min="1"
          placeholder="请输入" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { createCompanyUser, updateCompanyUser } from '@/api/company'

export default {
  name: 'AccountModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: null
    },
    accountList: {
      type: Array,
      default: () => []
    },
    corpId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title: '添加账号',
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initForm()
      }
    }
  },
  methods: {
    initForm () {
      this.form.resetFields()
      console.log(this.account)
      this.$nextTick(() => {
        if (this.account) {
          this.title = '编辑账号'
          this.form.setFieldsValue({
            username: this.account.username,
            mobile: this.account.mobile,
            max: this.account.max
          })
        } else {
          this.title = '添加账号'
          this.form.resetFields()
        }
      })
    },
    validateUserName (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入账号名称'))
        return
      }
      // 检查是否与已有账号重名
      const isDuplicate = this.accountList.some(item => {
        return item.accountName === value && (!this.account || item.id !== this.account.id)
      })
      if (isDuplicate) {
        callback(new Error('与已有账号重名'))
      } else {
        callback()
      }
    },
    validatePassword (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入账号密码'))
        return
      }
      if (value.length < 8) {
        callback(new Error('密码长度必须大于8位'))
        return
      }
      if (!/[A-Za-z]/.test(value) || !/\d/.test(value)) {
        callback(new Error('密码必须同时包含数字和字母'))
        return
      }
      callback()
    },
    handleOk () {
      const _this = this
      this.$nextTick(() => {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            setTimeout(() => {
              _this.confirmLoading = false
              console.log(values, _this.cropId, '1')
              values.corpId = _this.corpId
              values.roles = ['公司用户']
              if (this.account) {
                values.id = this.account.id
                updateCompanyUser(values)
                  .then(res => {
                    if (res.code === 1) {
                      _this.$message.success('账号更新成功')
                      _this.$emit('ok', res.data)
                    }
                  })
              } else {
                createCompanyUser(values).then(res => {
                  if (res.code === 1) {
                    _this.$message.success('账号创建成功')
                    _this.$emit('ok', res.data)
                  }
                })
              }

              _this.form.resetFields()
            }, 500)
          }
        })
      })
    },
    handleCancel () {
      this.form.resetFields()
      this.$emit('cancel')
    },
    load (account) {
      this.account = account
      this.initForm()
    }
  }
}
</script>

<style scoped>
.ant-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.ant-form-item-label {
  flex: 0 0 100px;
  text-align: left;
  margin-right: 8px;
}

.ant-form-item-control {
  flex: 1;
  margin-left: 0;
}

.ant-input,
.ant-input-number {
  width: 300px;
}
</style>
